// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3rZWi","bigColWidth":"Table_bigColWidth__1Pd0C","biggerColWidth":"Table_biggerColWidth__SP8gp","row":"Table_row__2MbGo","col":"Table_col__3X0TG"};